import React from "react";
import SOBreadCrumb from "../../Components/SO/SOBreadCrumb";
import SOListings from "../../Components/SO/SOListings";

export default function SOListing() {
  return (
    <React.Fragment>
      <div className="page-content">
        <SOBreadCrumb />
        <SOListings />
      </div>
    </React.Fragment>
  );
}
